import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProviderOverviewSkeleton = () => {
  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
      <section>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Skeleton for Website URL */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={100} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={200} />
            </dd>
          </div>

          {/* Skeleton for Est. Date */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={100} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={80} />
            </dd>
          </div>

          {/* Skeleton for Headquarters */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={100} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={200} />
            </dd>
          </div>

          {/* Skeleton for Secondary Locations */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={150} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700 flex items-center">
              <Skeleton width={200} />
              <Skeleton width={20} className="ml-2" />
            </dd>
          </div>

          {/* Skeleton for Languages */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={100} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={150} />
            </dd>
          </div>

          {/* Skeleton for Geographic Coverage */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={150} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={200} />
            </dd>
          </div>

          {/* Skeleton for Therapeutic Areas */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={150} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={200} />
            </dd>
          </div>

          {/* Skeleton for Indications */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={100} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              <Skeleton width={200} />
            </dd>
          </div>

          {/* Skeleton for Services & Technologies */}
          <div className="border-t border-gray-100 pt-4">
            <dt className="text-sm font-medium text-gray-900">
              <Skeleton width={150} />
            </dt>
            <dd className="mt-1 text-sm text-gray-700 pb-7">
              <Skeleton width={200} />
            </dd>
          </div>
        </dl>
      </section>
    </SkeletonTheme>
  );
};

export default ProviderOverviewSkeleton;
